import { render, staticRenderFns } from "./RegisterPerson.vue?vue&type=template&id=6e2c9d6c&scoped=true&"
import script from "./RegisterPerson.vue?vue&type=script&lang=js&"
export * from "./RegisterPerson.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPerson.vue?vue&type=style&index=0&id=6e2c9d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c9d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
